import { array, concat, get, hash } from '@ember/helper';
import { dasherize } from '@ember/string';
import Component from '@glimmer/component';

import cannot from 'ember-can/helpers/cannot';
import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';

import HlsStream from 'umg-ember-backend/components/ui/hls-stream';
import { imageUrl } from 'umg-ember-backend/helpers/image-url';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import AssetTools from './asset-tools';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordDetailFormsAssetInfoComponent extends Component {
  // Defaults
  metaInformation = {
    audio: [
      'audioCodec',
      'audioFrequenz',
      'audioBitrate',
      'audioChannels',
      'fileSize',
    ],
    document: ['fileSize'],
    image: ['resolution', 'fileSize'],
    video: ['videoCodec', 'resolution', 'durationString', 'mime', 'fileSize'],
  };

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <div class={{bem 'preview'}}>
        <div class={{bem 'media-wrapper'}}>
          {{#if @asset.isVideo}}
            <HlsStream @asset={{@asset}} class={{bem 'video'}} />
          {{else if @asset.isImage}}
            <img
              class={{bem 'image'}}
              src={{imageUrl (array @asset '4/1280')}}
              alt={{@asset.headline}}
            />
          {{else if @asset.isAudio}}
            <HlsStream @asset={{@asset}} class={{bem 'audio'}} />
          {{else}}
            <div
              class={{bem
                'document'
                (hash
                  mime=(dasherize (or @asset.sourceFormat.mime 'undefined'))
                )
              }}
            >
              {{#if @asset.sourceFormat.mime}}
                {{@asset.sourceFormat.mime}}
              {{else}}
                {{t 'record_detail.forms.asset.info.unknown_type'}}
              {{/if}}
            </div>
          {{/if}}
        </div>
      </div>
      <div class={{bem 'sidebar'}}>
        <div class={{bem 'meta'}}>
          {{#each (get this.metaInformation @asset.assetType) as |property|}}
            {{#if (get @asset.sourceFormat property)}}
              <div class={{bem 'property'}}>
                <div class={{bem 'label'}}>
                  {{t (concat 'record_detail.forms.asset.info.' property)}}
                </div>
                <div class={{bem 'value'}}>
                  {{get @asset.sourceFormat property}}
                </div>
              </div>
            {{/if}}
          {{/each}}
        </div>
        <div class={{bem 'asset-tools'}}>
          {{#unless (or @asset.isNew (cannot 'update' 'asset'))}}
            <AssetTools @asset={{@asset}} />
          {{/unless}}
        </div>
      </div>
    </div>
  </template>
}
